import React from 'react';
import { MapPin, Phone, Mail, Instagram, Youtube, Facebook } from 'lucide-react';

// Custom TikTok SVG component
const TikTok = ({ className = '' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 32 32"
    fill="currentColor"
    className={className}
    style={{ transform: 'translate(-2px, -2px)' }}
  >
    <path d="M28.5 10.5c-2.5 0-4.5-2-4.5-4.5h-4v18c0 2.2-1.8 4-4 4s-4-1.8-4-4 1.8-4 4-4c.3 0 .7 0 1 .1v-4.1c-.3 0-.7-.1-1-.1-4.4 0-8 3.6-8 8s3.6 8 8 8 8-3.6 8-8V14.5c1.2 1 2.7 1.5 4.5 1.5v-5.5z" />
  </svg>
);

const Footer = () => {
  return (
    <footer className="bg-gray-900 text-white pt-16 pb-8" id="contact">
      <div className="max-w-6xl mx-auto px-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Contact Information */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-primary-400">Contact</h3>
            <div className="space-y-4">
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-400">
                  <MapPin size={20} />
                </div>
                <p>
                  THE PHYT GYM<br />
                  Los Angeles, CA<br />
                  Serving clients nationwide
                </p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-400">
                  <Phone size={20} />
                </div>
                <p>Contact for booking</p>
              </div>
              
              <div className="flex items-start gap-3">
                <div className="flex-shrink-0 mt-1 text-primary-400">
                  <Mail size={20} />
                </div>
                <a href="mailto:phytgymla@gmail.com" className="hover:text-primary-400 transition">
                  phytgymla@gmail.com
                </a>
              </div>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-primary-400">Quick Links</h3>
            <div className="grid grid-cols-2 gap-2">
              <a href="/about" className="hover:text-primary-400 transition">About</a>
              <a href="/#packages" className="hover:text-primary-400 transition">Programs & Services</a>
              <a href="/#testimonials" className="hover:text-primary-400 transition">Testimonials</a>
              <a href="/blog" className="hover:text-primary-400 transition">Blog</a>
              <a href="/faq" className="hover:text-primary-400 transition">FAQ</a>
              <a href="/#contact" className="hover:text-primary-400 transition">Contact</a>
            </div>
          </div>

          {/* Social Media */}
          <div>
            <h3 className="text-2xl font-bold mb-6 text-primary-400">Follow Us</h3>
            <p className="mb-4">
              Follow Coach HT for fitness tips and motivation:
            </p>
            <div className="flex space-x-4">
              <a 
                href="https://www.instagram.com/thephytgym" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-400 hover:text-white transition"
                aria-label="Follow us on Instagram"
              >
                <Instagram size={20} />
              </a>
              <a 
                href="https://www.youtube.com/@thephytgym" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-400 hover:text-white transition"
                aria-label="Subscribe to our YouTube channel"
              >
                <Youtube size={20} />
              </a>
              <a 
                href="https://www.facebook.com/thephytgym" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-400 hover:text-white transition"
                aria-label="Like us on Facebook"
              >
                <Facebook size={20} />
              </a>
              <a 
                href="https://www.tiktok.com/@thephytgym" 
                target="_blank" 
                rel="noopener noreferrer"
                className="bg-white text-gray-900 w-10 h-10 rounded-full flex items-center justify-center hover:bg-primary-400 hover:text-white transition"
                aria-label="Follow us on TikTok"
              >
                <TikTok className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        {/* Bottom Section with Legal Links */}
        <div className="pt-8 border-t border-gray-700 text-sm">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p>&copy; 2025 THE PHYT GYM, all rights reserved.</p>
            <div className="flex flex-wrap gap-4 mt-4 md:mt-0">
              <a href="/terms" className="text-gray-400 hover:text-primary-400 transition">Terms & Conditions</a>
              <a href="/privacy-policy" className="text-gray-400 hover:text-primary-400 transition">Privacy Policy</a>
              <a href="/refund-policy" className="text-gray-400 hover:text-primary-400 transition">Refund Policy</a>
            </div>
          </div>
          
         
        </div>
      </div>
    </footer>
  );
};

export default Footer;